import React from "react";
import AppField from "../../../../components/AppField";
import AppRadioGroup from "../../../../components/AppRadioGroup";
import DocsNiceToKnow from "../../shared/DocsNiceToKnow";
import DocsPreviewPanel from "../../shared/DocsPreviewPanel";
import DocsSectionCard from "../../shared/DocsSectionCard";

const describedOptions = [
  {
    value: "fixed",
    label: "Fixe Zuteilung",
    description: "Wird direkt als feste Vorgabe übernommen.",
  },
  {
    value: "preferred",
    label: "Bevorzugt",
    description: "Wird als weiche Präferenz behandelt.",
  },
  {
    value: "automatic",
    label: "Automatisch",
    description: "Das System entscheidet anhand der restlichen Daten.",
  },
];

const labelOnlyOptions = [
  { value: "yes", label: "Ja" },
  { value: "no", label: "Nein" },
  { value: "later", label: "Später" },
];

const stateOptions = [
  { value: "manual", label: "Manuell" },
  { value: "automatic", label: "Automatisch" },
];

const niceToKnowItems = [
  "Description pro Option (Default) ist optional.",
  "Default Layout ist stacked/column.",
  "Inline nur für kurze Optionen ohne Description.",
  "labelVariant=\"body-1\" verwendet ein reguläres 14px-Label statt Label 1.",
];

function PreviewRow({ label, children }) {
  return (
    <div className="ds-docs-preview-row">
      <div className="ds-docs-preview-row__label">{label}</div>
      <div className="ds-docs-preview-row__content">{children}</div>
    </div>
  );
}

function StateExample({ title, children }) {
  return (
    <div className="ds-docs-radio-preview__state">
      <div className="ds-docs-radio-preview__state-title">{title}</div>
      {children}
    </div>
  );
}

export default function RadioGroupsDocs() {
  return (
    <DocsSectionCard title="Radio Groups">
      <div className="ds-docs-spotlight-grid">
        <DocsPreviewPanel>
          <div className="ds-docs-preview-surface ds-docs-radio-preview">
            <PreviewRow label="Default">
              <AppRadioGroup options={describedOptions} defaultValue="preferred" />
            </PreviewRow>

            <PreviewRow label="Nur Label">
              <AppRadioGroup options={labelOnlyOptions} defaultValue="yes" />
            </PreviewRow>

            <PreviewRow label="Regular label">
              <AppRadioGroup labelVariant="body-1" options={labelOnlyOptions} defaultValue="yes" />
            </PreviewRow>

            <PreviewRow label="Inline">
              <AppRadioGroup direction="row" options={labelOnlyOptions} defaultValue="yes" />
            </PreviewRow>

            <PreviewRow label="States">
              <div className="ds-docs-radio-preview__states">
                <StateExample title="Disabled">
                  <AppRadioGroup disabled options={stateOptions} defaultValue="manual" />
                </StateExample>

                <StateExample title="Error">
                  <AppField label="Verfahren" error="Bitte Option auswählen.">
                    <AppRadioGroup invalid options={stateOptions} />
                  </AppField>
                </StateExample>
              </div>
            </PreviewRow>
          </div>
        </DocsPreviewPanel>

        <DocsNiceToKnow items={niceToKnowItems} />
      </div>
    </DocsSectionCard>
  );
}
